import React from "react";
import { formatDate } from "src/views/CampaignDetail/utils";
import * as S from "../../../../../constants/StringConstants";

const CommentInfo = ({ commentDetails }) => {
  if (!commentDetails) return null;

  return (
    <div>
      <div className="app-form-header">
        <h4 className="form-title">{S.APP_COMMENTS_COMMENT_SECTION_TITLE}</h4>
      </div>

      <div className="comments-detail__section-inner-container">
        <div className="comments-detail__info-container">
          <div>
            <label>{S.APP_COMMENTS_APPLICATION_ID_LABEL}:</label>
            <span>{commentDetails.applicationID || "-"}</span>
          </div>

          <div>
            <label>{S.APP_COMMENTS_POLICY_NUMBER_LABEL}:</label>
            <span>{commentDetails.policyNumber || "-"}</span>
          </div>

          <div>
            <label>{S.APP_COMMENTS_PROPOSED_INSURED_LABEL}:</label>
            <span>{commentDetails.proposedInsured || "-"}</span>
          </div>

          <div>
            <label>{S.APP_COMMENTS_CARRIER_LABEL}:</label>
            <span>{commentDetails.carrier || "-"}</span>
          </div>
        </div>

        <div className="comments-detail__info-container">
          <div>
            <label>{S.APP_COMMENTS_APPLICATION_TYPE_LABEL}:</label>
            <span>{"-"}</span>
          </div>
          <div>
            <label>{S.APP_COMMENTS_DATE_CREATED_LABEL}:</label>
            <span>{formatDate(commentDetails.created) || "-"}</span>
          </div>

          <div>
            <label>{S.APP_COMMENTS_LAST_UPDATED_LABEL}:</label>
            <span>{formatDate(commentDetails.modified) || "-"}</span>
          </div>

          <div>
            <label>{S.APP_COMMENTS_CREATED_BY_LABEL}:</label>
            <span>{commentDetails.createdByUser || "-"}</span>
          </div>
        </div>

        <div className="comments-detail__info-container">
          <div>
            <label>{S.APP_COMMENTS_CONTACT_LABEL}:</label>
            <span>{commentDetails.contact || "-"}</span>
          </div>

          <div>
            <label>{S.APP_COMMENTS_CONTACT_TAX_ID_LABEL}:</label>
            <span>{commentDetails.contactTaxId || "-"}</span>
          </div>

          <div>
            <label>{S.APP_COMMENTS_CONTACT_EMAIL_LABEL}:</label>
            <span>{commentDetails.contactEmail || "-"}</span>
          </div>

          <div>
            <label>{S.APP_COMMENTS_CONTACT_PHONE_LABEL}:</label>
            <span>{commentDetails.contactPhone || "-"}</span>
          </div>
        </div>

        <div className="comments-detail__info-container">
          <div>
            <label>{S.APP_COMMENTS_CHANGED_BY_LABEL}:</label>
            <span>{commentDetails.modifiedByUser || "-"}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommentInfo;
